export const organizationConfig = {
  brandName: "Flaviar",
  productName: "Flaviar Checkout",
  legalEntityName: "Flaviar, Inc.",
  businessUrl: "https://business.flaviar.com",
  helpEmail: "help@flaviar.com",
  businessEmail: "business@flaviar.com",
  senderEmail: "no-reply@flaviar.com",
  notificationRecipients: [
    "riyam.arabo@flaviar.com",
    "acacio@flaviar.com",
  ],
  notificationCc: "eliana.garcia@flaviar.com",
  intercomInboxName: "FL Checkout",
  verificationEmailSearchQuery: "Flaviar verify your email address",
  locationSettings: {
    name: "Flaviar Checkout",
    address: {
      address1: "244 5th Ave F247",
      address2: null as string | null,
      city: "New York",
      province: "New York",
      provinceCode: "NY",
      country: "United States",
      countryCode: "US",
      zip: "10001",
    },
    phone: "646-671-2451",
  },
  orderStatusBlockInstallUrl:
    "https://admin.shopify.com/oauth/install_custom_app?client_id=2ecd06b0ac6be2723bcb67f75f2bd4b3&no_redirect=true&signature=eyJleHBpcmVzX2F0IjoxNzU2MjMzOTc2LCJwZXJtYW5lbnRfZG9tYWluIjoic3RhZ2luZy1tYXNoLm15c2hvcGlmeS5jb20iLCJjbGllbnRfaWQiOiIyZWNkMDZiMGFjNmJlMjcyM2JjYjY3Zjc1ZjJiZDRiMyIsInB1cnBvc2UiOiJjdXN0b21fYXBwIiwibWVyY2hhbnRfb3JnYW5pemF0aW9uX2lkIjo4OTI3NzU0Nn0%3D--98b582a969ab19b9efa12ac9b8793d9f5f421c79",
} as const;
